import { z } from 'zod';
import { Box } from '@/shared/ui';

import { ItemSelection } from '@/features/dashboard/components/AppForm/AppForm/components/ItemSelection';
import type { TileValues } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { DrawerStep } from '@/features/dashboard/components/Drawer/types';
import Heading from '@/features/dashboard/components/Heading';
import type { TilesWidgetV2 } from '@/features/dashboard/types';
import { AppType } from '@/features/dashboard/types';

import { HIGHLIGHTED_PRICE_MAX_ITEMS } from '@/features/dashboard/constants/const';
import type { FormAppDefinition } from '../types';
import { buildId, seriesToSymbols, SymbolsStateSchema } from './_helpers';

export const highlightedPriceDefinition: FormAppDefinition<TileValues, TilesWidgetV2> = {
  type: AppType.Tiles,
  drawerStep: DrawerStep.SelectHighlightedPrice,
  dashboardControls: { edit: true },
  maxItems: HIGHLIGHTED_PRICE_MAX_ITEMS,
  initialValues: {
    type: AppType.Tiles,
    symbols: { active: [], backlog: [] }
  },
  schema: z.object({
    type: z.literal(AppType.Tiles),
    symbols: SymbolsStateSchema
  }),
  Form: () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Heading
        subtitle='Set up your preferences and data'
        title='Configure highlighted price'
      />
      <ItemSelection />
    </Box>
  ),
  toWidget: values => ({
    id: 'tiles',
    name: '',
    metadata: null,
    type: 'tiles',
    tiles: values.symbols.active.map(symbol => ({
      id: buildId(symbol.symbol),
      shortTitle: symbol.shortTitle,
      symbol: { key: symbol.symbol, group: 'Prod_Indexes' }
    }))
  }),
  canEditWidget: (w): w is TilesWidgetV2 => w.type === 'tiles',
  fromWidget: w => ({
    type: AppType.Tiles,
    symbols: { active: seriesToSymbols(w.tiles), backlog: [] }
  })
};
